var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Touch',{ref:"touchWrapper",on:{"tmove":_vm.activeScroll,"tend":_vm.scrollEnd}},[_c('div',{ref:"scrollContent",staticClass:"scrollContent"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }